/* eslint-disable no-nested-ternary */
import styled from 'styled-components'
import Link from 'next/link'
import { SecondaryButton, NeutralButtonOutline } from 'common/button'
import { Typography } from 'common/typography'
import HeroIlustration from 'projects/landing-ilustrations/hero-ilustration'
import { dottedBackground } from 'projects/background/background-patron'
import { useSubscriptionStatus } from 'querys/subscriptions'
import useSession from 'querys/session'

const ProjectsSectionStyled = styled.section`
  ${dottedBackground};
  &::before {
    top: 0;
  }
  .hero-container{
    padding: 0 16px;
    max-width: 1270px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 16px;
    margin: 0 auto;
  }
  .section-content {
    margin-top: 86px;
    max-width: 600px;
  }
  p {
    max-width: 500px;
    padding: 16px 0 24px;
  }
  .hero-btn {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 16px;
  }
  h2 {
    color: var(--baseNeutral);
    font-size: 32px;
    line-height: 40px;
  }
  @media(min-width: 768px) {
    .hero-container {
      padding: 0 0 0 3rem;
    }
  }
  @media(min-width: 1024px) {
    margin-bottom: 80px;
    h2 {
      font-size: 54px;
      line-height: 60px;
    }
    .hero-container {
      flex-direction: row;
    }
    .section-content {
      margin-top: 95px;
      margin-right: 40px;
    }
    .hero-btn {
      grid-template-columns: repeat(2, min-content);
    }
    p {
      padding: 16px 0 32px;
    }
  }
  @media(min-width: 1366px) {
    h2 {
      font-size: 64px;
      line-height: 80px;
    }
    .section-content {
      margin-top: 156px;
      margin-right: 0;
    }
    .hero-container {
      padding: 0 0 0 5rem;
    }
  }
`

function ProjectsHero() {
  const { token, isStale } = useSession()
  const { data: { is_active } } = useSubscriptionStatus({ product: 'PROJECTS' })
  return (
    <ProjectsSectionStyled aria-label="/Proyectos">
      <div className="hero-container">
        <div className="section-content">
          <h2 as="h2">
            La práctica hace al maestro
          </h2>
          <Typography as="p" color="var(--baseNeutral)">
            Usa tus habilidades para crear un excelente portafolio y conseguir el trabajo de tus sueños,
            {' '}
            <strong>nosotros nos encargamos del diseño</strong>
            .
          </Typography>
          <div className="hero-btn">
            {!isStale && (
              !token ? (
                <>
                  <Link href="/registro?next=/proyectos" passHref>
                    <NeutralButtonOutline>Regístrate</NeutralButtonOutline>
                  </Link>
                  <Link href="/login?next=/proyectos" passHref>
                    <SecondaryButton id="projects-hero">Iniciar sesión</SecondaryButton>
                  </Link>
                </>
              ) : (
                is_active ? (
                  <Link href="/proyectos/todos" passHref>
                    <SecondaryButton>Ver proyectos</SecondaryButton>
                  </Link>
                ) : (
                  <Link href="/comprar/proyectos" passHref>
                    <SecondaryButton>Suscribirme</SecondaryButton>
                  </Link>
                )
              )
            )}
          </div>
        </div>
        <HeroIlustration />
      </div>
    </ProjectsSectionStyled>
  )
}

export default ProjectsHero
